import request from '@/utils/request'

const prefix = '/django_rest/client-admin/site-message'

export default {
  getSiteMessageList (params) {
    return request.get(`${prefix}/`, { params })
  },
  createSiteMessage (params) {
    return request.post(`${prefix}/`, params)
  },
  getSiteMessageInfoByMessageId (messageId) {
    return request.get(`${prefix}/${messageId}/`)
  }
}
